import { createLoader } from '@meteor/data-hooks';
import { useRef, useState } from 'react';
import { withAuth } from '../../user';
import { agentClient } from '../client';

export let agentsLoader = createLoader({
  name: 'agents',
  hash: i => i.instanceId,
  fetch: (i: { instanceId: string }) => withAuth(() => agentClient.agent.list(i)),
  mutators: {
    create: (i: { name: string; slug: string }, { input }) =>
      withAuth(() => agentClient.agent.create({ ...input, ...i }))
  }
});

export let useAgents = (instanceId: string | null | undefined) => {
  let agents = agentsLoader.use(instanceId ? { instanceId } : null);

  return {
    ...agents,
    createMutator: agents.useMutator('create')
  };
};

export let agentLoader = createLoader({
  name: 'agent',
  hash: i => i.agentId + i.instanceId,
  parents: [agentsLoader],
  fetch: (i: { agentId: string; instanceId: string }) =>
    withAuth(() => agentClient.agent.get(i)),
  mutators: {
    update: (
      i: {
        name?: string;
      },
      { input }
    ) =>
      withAuth(() =>
        agentClient.agent.update({
          ...input,
          ...i
        })
      ),

    delete: (_, { input }) => withAuth(() => agentClient.agent.delete(input))
  }
});

export let useAgent = (
  instanceId: string | null | undefined,
  agentId: string | null | undefined
) => {
  let agent = agentLoader.use(agentId && instanceId ? { agentId, instanceId } : null);

  return {
    ...agent,
    updateMutator: agent.useMutator('update'),
    deleteMutator: agent.useMutator('delete')
  };
};

export let agentReleasesLoader = createLoader({
  name: 'agent_releases',
  hash: i => i.agentId + i.instanceId + i.cursor,
  fetch: (i: { agentId: string; instanceId: string; cursor?: string }) =>
    withAuth(() =>
      agentClient.agent.release.list({
        ...i,
        limit: 50,
        order: 'desc'
      })
    ),
  mutators: {}
});

export let useAgentReleases = (
  instanceId: string | null | undefined,
  agentId: string | null | undefined
) => {
  let [cursor, setCursor] = useState<string>();
  let releases = agentReleasesLoader.use(
    agentId && instanceId ? { agentId, instanceId, cursor } : null
  );

  let dataRef = useRef(releases.data);
  dataRef.current = releases.data;

  return {
    ...releases,
    next: () => {
      let c = dataRef.current?.pagination.afterCursor;
      if (c) setCursor(c);
    },
    previous: () => {
      let c = dataRef.current?.pagination.beforeCursor;
      if (c) setCursor(c);
    }
  };
};

export let mostRecentAgentUpdateLoader = createLoader({
  name: 'agent_releases',
  hash: i => i.agentId + i.instanceId,
  fetch: (i: { agentId: string; instanceId: string }) =>
    withAuth(() => agentClient.agent.release.getMostRecentUpdate(i)),
  mutators: {}
});

export let useMostRecentAgentUpdate = (
  instanceId: string | null | undefined,
  agentId: string | null | undefined
) => {
  let update = mostRecentAgentUpdateLoader.use(
    agentId && instanceId ? { agentId, instanceId } : null
  );

  return update;
};
